<!-- BSG-compliant food item modal with keyboard accessibility -->
<div class="bsg-modal-container">
	<!-- Skip link for keyboard users -->
	<a href="#food-options" class="bsg-skip-link">Skip to food options</a>

	<swiper-container
		#swiperInfo
		(ionSlideDidChange)="onSlideChange()"
		loop="true"
		allow-touch-move="false"
		[options]="slideOpts"
		role="dialog"
		aria-labelledby="food-item-title"
	>
		<ng-container *ngFor="let page of pages; let pageIndex = index">
			<ng-container *ngIf="pageVisible(pageIndex)">
				<swiper-slide class="first-page" [class.overlay-slide]="isPageOverlay(pageIndex)">
					<ion-col class="slide-col ion-no-padding" [class.add-background]="pageIndex != 0">
						<div class="style-block">
							<!-- Main food item details (first page) -->
							<div *ngIf="pageIndex == 0">
								<div class="header-wrapper">
									<!-- Back button with keyboard accessibility -->
									<button class="back_btn bsg-back-button" (click)="close()" tabindex="0" aria-label="Back to menu">
										<ion-icon src="../../../assets/dean_and_david/back.svg" aria-hidden="true"></ion-icon>
										<span class="visually-hidden">Back</span>
									</button>

									<!-- Category heading with appropriate level -->
									<h2 class="category-heading">
										{{ articleGroup?.categoryName | langObservable | async }}
									</h2>

									<!-- Favorite button with enhanced accessibility -->
									@if (showMostWanted) {
										<div class="add_fav_btn" tabindex="0" role="button" aria-label="Popular item" aria-pressed="true">
											<ion-icon
												[src]="'../../../assets/dean_and_david/added-favourite.svg'"
												aria-hidden="true"
											></ion-icon>
											<span class="visually-hidden">Popular item</span>
										</div>
									} @else {
										<div class="add_fav_btn no-shadow"></div>
									}
								</div>

								<!-- Food image with improved alt text -->
								<figure class="image-wrapper" role="img">
									<ion-img
										class="main-img full-width"
										*ngIf="articleGroup.article.assets.large"
										[src]="articleGroup.article.assets.large"
										[attr.alt]="'Image of ' + (articleGroup.article.name | langObservable | async)"
									></ion-img>

									<ion-img
										class="main-img default-img"
										*ngIf="!articleGroup.article.assets.large"
										src="../../../assets/dean_and_david/logo-big.png"
										alt="Dean and David logo"
									></ion-img>
								</figure>

								<!-- Food item info -->
								<div class="info">
									<ion-row>
										<ion-col class="ion-no-padding" size="12">
											<!-- Vegan/dietary label with improved accessibility -->
											<ng-container *ngIf="checkVeganFeatureValue">
												<div class="vegan-block" aria-live="polite" role="status">
													<ion-img
														[src]="
															'../../../assets/dean_and_david/slider-veggie/' +
															checkVeganFeatureValue +
															'.png'
														"
														[attr.alt]="checkVeganFeatureValue + ' food item'"
													></ion-img>
												</div>
											</ng-container>

											<!-- Item title and info button -->
											<h1 id="food-item-title" class="title">
												{{ articleGroup.article.name | langObservable | async }}

												<!-- Info button with keyboard accessibility -->
												<button
													class="info_block bsg-info-button"
													(click)="showNutrition(articleGroup.article)"
													tabindex="0"
													aria-label="View nutrition information"
												>
													<ion-icon src="../../../assets/dean_and_david/info.svg" aria-hidden="true"></ion-icon>
													<span class="visually-hidden">Nutrition information</span>
												</button>
											</h1>

											<!-- Item description -->
											<p class="desc">
												{{ articleGroup.article.description | langObservable | async }}
											</p>
										</ion-col>

										<!-- Remove ingredients button with improved accessibility -->
										<div class="ingrediants-section" *ngIf="checkOptionGroup(articleGroup.article.groups)">
											<button
												class="bsg-remove-ingredients-button"
												(click)="openRemoveIngredients(articleGroup.article.groups)"
												tabindex="0"
												aria-label="Remove ingredients"
											>
												{{ 'modal_info.remove_ingredients' | translate }}
											</button>
										</div>
									</ion-row>
								</div>
							</div>

							<!-- Food options section with improved navigation -->
							<div id="food-options" tabindex="-1" aria-labelledby="food-options-heading"></div>
							<h2 id="food-options-heading" class="visually-hidden">Food options</h2>

							<ng-container *ngFor="let optionGroup of page; let optionGroupIndex = index">
								<ng-container
									*ngIf="
										validationUtils.isGroupDependencyFulfilled(
											articleGroup.article,
											articleGroup.groups,
											optionGroup
										) as dependency
									"
								>
									<ng-container
										*ngIf="
											dependency.times >= 0 &&
											optionGroup.visible &&
											!(optionGroup.articles.length === 1 && optionGroup.limit === 1)
										"
									>
										<ng-container *ngFor="let dependencyNumber of generateDependencies(dependency)">
											<ng-container *ngIf="checkIfArticleIsVisible(optionGroup)">
												<!-- Option group heading -->
												<div class="show-option-groups" [attr.id]="'option-section-' + optionGroupIndex">
													<h3
														[id]="'option-group-' + optionGroupIndex"
														[innerHTML]="optionGroup.description | langObservable | async"
														class="option-group-description"
													></h3>
												</div>

												<!-- Option group selection -->
												<ion-col
													class="option-group-col"
													role="group"
													[attr.aria-labelledby]="'option-group-' + pageIndex"
												>
													<app-article-option-group-custom
														(selection)="
															add(
																pageIndex,
																optionGroupIndex,
																$event,
																optionGroup,
																dependency,
																dependencyNumber
															)
														"
														[article]="articleGroup.article"
														[currency]="order && order.currency"
														[optionGroup]="optionGroup"
														[preorderType]="order.preorder.type"
														[selected]="filterMatchingOptions(articleGroup.groups, optionGroup, dependency)"
													>
													</app-article-option-group-custom>
												</ion-col>
												<div *ngIf="optionGroupIndex === page.length - 1" class="last-item"></div>
											</ng-container>
										</ng-container>
									</ng-container>
								</ng-container>
							</ng-container>
							<!-- placeholder if no options on first page -->
							<ion-col *ngIf="pages.length >= 1 && pages[0].length == 0" class="option-group-col"> </ion-col>
							<div class="input-notes" *ngIf="isNoticeable" role="region" aria-label="Input notes">
								<div class="container">
									<ion-label class="stacked bfsg-access-label" for="notes-input">{{
										'order.note.header' | translate
									}}</ion-label>
									<ion-item>
										<ion-input
											id="notes-input"
											[formControl]="enterNotes"
											maxlength="50"
											aria-describedby="notes-input-hint"
											[placeholder]="'order.note.placeholder' | translate"
											aria-label="{{ 'order.note.header' | translate }}"
										></ion-input>
									</ion-item>
									<div id="notes-input-hint" class="visually-hidden">Maximum 50 characters</div>
								</div>
							</div>
							<div *ngIf="order" class="ion-margin button-footer-block">
								<div class="footer-price-section">
									<p class="text-hint">Price</p>
									<div class="wrapper-with-quantity">
										<h3 class="price-text">
											{{
												numberToCurrency(
													OrderUtils.totalPrice(articleGroup, order.type, order.preorder.type),
													order.currency
												)
											}}
										</h3>
										<div class="quantity-selector" *ngIf="!noQuantity">
											<ion-icon
												class="quantity-btn"
												[class.add-opacity]="articleGroup.quantity <= 1"
												(click)="
													articleGroup.quantity > 1 ? (articleGroup.quantity = articleGroup.quantity - 1) : null
												"
												src="../../../assets/dean_and_david/minus.svg"
											></ion-icon>
											<p class="quantity">{{ articleGroup.quantity }}</p>
											<ion-icon
												class="quantity-btn"
												(click)="articleGroup.quantity = articleGroup.quantity + 1"
												src="../../../assets/dean_and_david/plus.svg"
											></ion-icon>
										</div>
									</div>
								</div>

								<!-- Footer with price and add to order button -->
								<div *ngIf="order" class="ion-margin button-footer-block">
									<!-- Price section with proper semantics -->
									<div class="footer-price-section">
										<p class="text-hint" id="price-label">Price</p>
										<div class="wrapper-with-quantity">
											<h3 class="price-text" aria-labelledby="price-label">
												{{
													numberToCurrency(
														OrderUtils.totalPrice(articleGroup, order.type, order.preorder.type),
														order.currency
													)
												}}
											</h3>

											<!-- Quantity selector with improved keyboard accessibility -->
											<div class="quantity-selector" *ngIf="!noQuantity" aria-label="Quantity selector">
												<button
													class="quantity-btn bsg-quantity-decrease"
													[class.add-opacity]="articleGroup.quantity <= 1"
													[attr.disabled]="articleGroup.quantity <= 1 ? 'disabled' : null"
													(click)="
														articleGroup.quantity > 1
															? (articleGroup.quantity = articleGroup.quantity - 1)
															: null
													"
													tabindex="0"
													aria-label="Decrease quantity"
												>
													<ion-icon src="../../../assets/dean_and_david/minus.svg" aria-hidden="true"></ion-icon>
													<span class="visually-hidden">Decrease</span>
												</button>

												<p class="quantity" aria-live="polite">{{ articleGroup.quantity }}</p>

												<button
													class="quantity-btn bsg-quantity-increase"
													(click)="increase()"
													tabindex="0"
													aria-label="Increase quantity"
												>
													<ion-icon src="../../../assets/dean_and_david/plus.svg" aria-hidden="true"></ion-icon>
													<span class="visually-hidden">Increase</span>
												</button>
											</div>
										</div>
									</div>

									<!-- Add to order button with improved keyboard support -->
									<ion-button
										(click)="addToOrder(true)"
										*ngIf="articleGroup.article.isActive"
										[disabled]="!isCloseButtonValid"
										expand="block"
										tabindex="0"
										(keydown.enter)="addToOrder(true)"
										(keydown.space)="addToOrder(true)"
										[attr.aria-label]="'Add ' + (articleGroup.article.name | langObservable | async) + ' to order'"
									>
										<h2 class="buuton-text" [class.one-button]="!checkIfButtonFinishedAvailable">
											{{ 'menu_page.order_btn' | translate }}
										</h2>
										<ion-icon
											class="button-icon"
											src="../../../assets/losteria/button-arrow.svg"
											aria-hidden="true"
										></ion-icon>
									</ion-button>

									<!-- Not available button -->
									<ion-button
										*ngIf="!articleGroup.article.isActive"
										[disabled]="true"
										expand="block"
										tabindex="-1"
										aria-label="Item not available"
									>
										<h2 class="buuton-text">
											{{ 'not_available' | translate }}
										</h2>
									</ion-button>
								</div>
							</div>
						</div>
					</ion-col>
				</swiper-slide>
			</ng-container>
		</ng-container>
	</swiper-container>
</div>
